import { useMutation, useQueryClient } from "@tanstack/react-query";

//** Request/Response mappings */
import { createQuoteRequestMapping } from "../../mapping/createQuoteRequestMapping.js";
import { createQuoteResponseMapping } from "../../mapping/createQuoteResponseMapping.js";
import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

import { queryKeys } from "./queryKeys.js";

//----------------------------------------------------------------
const putUpdateCover = async (requestData) => {
	if (requestData == null) {
		return;
	}

	try {
		const { updateData, accessToken, outcomeData } = {
			...requestData,
		};
		let mappedRequest = await createQuoteRequestMapping(
			updateData,
			outcomeData
		);

		const response = await request({
			url: "/updateQuote?coversOnly=true",
			method: "PUT",
			data: JSON.stringify(mappedRequest),
			accessToken: accessToken,
		});
		if (200 === response.status) {
			return createQuoteResponseMapping(response);
		} else {
			throw response;
		}
	} catch (error) {
		console.error("UpdateCover Error ", error);
		throw error;
	}
};

export const useUpdateCoverMutation = () => {
	const queryClient = useQueryClient();
	const { openErrorModal } = useSharedData();

	return useMutation({
		mutationFn: (data) => {
			return putUpdateCover(data);
		},
		onSuccess: (data) => {
			//* Save the response to the TanStack cache.
			if (data != null) {
				queryClient.setQueryData([queryKeys.QUOTE_DATA_GET], data || {});
				queryClient.invalidateQueries(["premiumProjectionData"]);
			} else {
				openErrorModal();
			}
		},
		onError: (err) => {
			openErrorModal();
			// Do something when an error is thrown
			console.log("Error", err);
		},
	});
};
